import React, { FC, useContext } from "react";
import FilterCategorySelected from "../filterCategorySelected";
import FilterCategoryTitle from "../filterCategoryTitle";

import { RadioGroup } from "@headlessui/react";
import classNames from "../../utils/twClassNames";

import { Gender, GenderName } from "../filterMenuSearch/FilterMenuSearch";
import { TranslationContext } from "../../context/TranslationContext";
import getGenderId, { getGenderName } from "../../utils/getGenderId";

type WithIdProps = {
  hasSmallSpacing?: boolean;
  label?: string;
  genders: Gender[];
  selectedGenderName?: never;
  setSelectedGenderName?: never;
  selectedGenderId?: 1 | 2 | -1;
  setSelectedGenderId?: (id: 1 | 2 | -1) => void;
};

type WithNameProps = {
  hasSmallSpacing?: boolean;
  label?: string;
  genders: Gender[];
  selectedGenderName?: GenderName;
  setSelectedGenderName?: (name: GenderName) => void;
  selectedGenderId?: never;
  setSelectedGenderId?: never;
};

type Props = WithIdProps | WithNameProps;

const GenderToggles: FC<Props> = ({
  hasSmallSpacing = false,
  label,
  genders,
  selectedGenderName,
  setSelectedGenderName,
  selectedGenderId,
  setSelectedGenderId,
}) => {
  const { i } = useContext(TranslationContext);

  selectedGenderName = selectedGenderName
    ? selectedGenderName
    : getGenderName(selectedGenderId as 1 | 2 | -1);

  return (
    <div className="GenderToggles max-w-3xl">
      <RadioGroup
        value={selectedGenderName}
        onChange={(event: GenderName) => {
          if (setSelectedGenderId) {
            const genderId = getGenderId(event);

            setSelectedGenderId(genderId);

            return;
          }

          if (setSelectedGenderName) {
            setSelectedGenderName(event as GenderName);
            return;
          }
        }}
      >
        <div className="flex flex-row justify-between">
          <RadioGroup.Label>
            <FilterCategoryTitle title={label || i("Looking for")} />
          </RadioGroup.Label>
          <FilterCategorySelected selectedCategory={i(selectedGenderName)} />
        </div>
        <div
          className={classNames(
            hasSmallSpacing ? "space-x-[15px]" : "space-x-[20px]",
            "flex items-center"
          )}
        >
          {genders.map((gender, index) => (
            <RadioGroup.Option
              key={gender.name}
              value={gender.name}
              data-testid={`gender-${index}`}
              className={({ active, checked }) =>
                classNames(
                  checked ? "bg-custom-orange" : "bg-custom-gray",
                  "h-[45px] w-1/3 rounded-md flex items-center justify-center cursor-pointer focus:outline-none tooltip relative"
                )
              }
            >
              <img
                alt={gender.name}
                className={classNames(
                  selectedGenderName == gender.name
                    ? "opacity-100"
                    : "opacity-70",
                  "fill-white select-none"
                )}
                src={`/app/assets/${gender.icon}.svg`}
              />
              <div
                className={classNames(
                  gender.name == "Both" ? "left-7" : "left-5",
                  "absolute top-[46px]"
                )}
              >
                <p
                  className={classNames(
                    gender.name == "Both" ? "w-24" : "w-20",
                    "tooltiptext"
                  )}
                >
                  {i(gender.name)}
                </p>
              </div>
            </RadioGroup.Option>
          ))}
        </div>
      </RadioGroup>
    </div>
  );
};

export default GenderToggles;
